import classNames from 'classnames';
import { t } from 'ttag';

import { Title } from '@ui/Title';
import { Grid } from '@components/Grid';
import { ProductCard, Product } from '@components/ProductCard';

import s from './ProductDetailsTopSellersProducts.sss';

interface Props {
  className?: string,
  products: Product[],
}

export const ProductDetailsTopSellersProducts: React.FC<Props> = ({
  className,
  products,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type="h3"
        bold={false}
      >
        {t`Товари від Супер-продавців`}
      </Title>

      <Grid
        container={true}
        spacing={10}
      >
        {products.map((product) => (
          <Grid
            key={product.id}
            desktop={3}
            tablet={4}
            def={6}
          >
            <ProductCard
              {...product}
              type="ProductDetailsProducts"
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
